// extracted by mini-css-extract-plugin
module.exports = {"fixedWidth":"Table_fixedWidth__39y9d"};